import { render } from "./TabTemplate.vue?vue&type=template&id=17898ed3&scoped=true&ts=true"
import script from "./TabTemplate.vue?vue&type=script&lang=ts"
export * from "./TabTemplate.vue?vue&type=script&lang=ts"

import "./TabTemplate.vue?vue&type=style&index=0&id=17898ed3&scoped=true&lang=postcss"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17898ed3"]])

export default __exports__